import React from 'react';
import Header, { HeaderLeft, HeaderRight } from '../../../layout/Header/Header';
import Popovers from '../../../components/bootstrap/Popovers';
import { useSelector } from 'react-redux';
import './../../../styles/custom/avatar.scss';

const DefaultHeader = () => {
	const currentEmployee = useSelector(
		(state: any) => state.employee?.currentEmployee?.data?.employee?.employee_name,
	);

	const getInitials = (name: string) => {
		if (!name) return '';
		const parts = name.trim().split(' ');
		const firstInitial = parts[0]?.charAt(0).toUpperCase();
		const lastInitial = parts[1]?.charAt(0).toUpperCase() || '';
		return firstInitial + lastInitial;
	};

	const initials = getInitials(currentEmployee);

	return (
		<Header>
			<HeaderLeft>Convier Solutions Management System</HeaderLeft>
			<HeaderRight>
				<Popovers
					title={initials}
					desc={currentEmployee}
					flip={['bottom', 'top']}
					isDisplayInline>
					<div className='flip-container'>
						<span className='flip-avatar'>{initials}</span>
					</div>
				</Popovers>
			</HeaderRight>
		</Header>
	);
};

export default DefaultHeader;
